import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter, Youtube, Phone, Mail, X } from 'lucide-react';

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <footer className="bg-[#001f3f] text-white pt-12">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 border-b border-blue-800 pb-10">
        {/* Logo & Description */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-2">AG EDU HUB Foundation</h2>
          <p className="text-sm text-gray-300">Your Trusted Global Education Partner</p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-gray-300">
            <li><Link to="/About" className="hover:text-white transition">About</Link></li>
            <li><button onClick={() => setShowPrivacy(true)} className="hover:text-white transition">Privacy Policy</button></li>
            <li><button onClick={() => setShowTerms(true)} className="hover:text-white transition">Terms of Use</button></li>
            <li><Link to="/Contact" className="hover:text-white transition">Contact</Link></li>
          </ul>
        </div>

        {/* Address */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Our Address</h4>
          <address className="text-sm text-gray-300 leading-relaxed">
            AG EDU HUB Foundation<br />
            Registered: Hno 1567, Maruti Kunj,<br />
            Bhondsi, Gurugram, 122102<br />
            Branch:  Rohtak, 124001<br />
            <br />
            <Phone size={16} className="inline-block mr-1" /> +91-8810605135<br />
            <Mail size={16} className="inline-block mr-1" /> <a href="mailto:info@ageduhub.in" className="hover:text-white">info@ageduhub.in</a>
          </address>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Subscribe to Newsletter</h4>
          <form className="flex flex-col gap-3">
            <input type="email" placeholder="Your Email" className="px-4 py-2 rounded-md text-black" required />
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 transition px-4 py-2 rounded-md text-white"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Social Section */}
      <div className="max-w-7xl mx-auto px-4 mt-6 flex flex-col md:flex-row justify-between items-center gap-6 pb-6">
        <div className="flex gap-4 text-white">
          <a href="https://www.facebook.com/share/1CU1as59Yq/" target="_blank" rel="noopener noreferrer"><Facebook size={20} /></a>
          <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><Twitter size={20} /></a>
          <a href="https://www.linkedin.com/in/ag-eduhub-b15466360" target="_blank" rel="noopener noreferrer"><Linkedin size={20} /></a>
          <a href="https://www.instagram.com/ag_eduhub/" target="_blank" rel="noopener noreferrer"><Instagram size={20} /></a>
          <a href="https://youtube.com/@ag_eduhub" target="_blank" rel="noopener noreferrer"><Youtube size={20} /></a>
        </div>

        <a
          href="https://wa.me/918810605135?text=Hi%2C%20I%20want%20to%20know%20about%20the%20programmes"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full flex items-center gap-2 transition"
        >
          <i className="fab fa-whatsapp"></i> Chat with Us
        </a>
      </div>

      {/* Copyright */}
      <div className="bg-[#001934] py-4 text-center text-sm text-gray-400">
        &copy; {new Date().getFullYear()} AG EDU HUB Foundation. All rights reserved.
      </div>

      {/* Modal - Privacy Policy */}
      {showPrivacy && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex justify-center items-center p-4" onClick={() => setShowPrivacy(false)}>
          <div className="bg-white text-black max-w-2xl w-full p-6 rounded-lg relative overflow-y-auto max-h-[80vh]" onClick={(e) => e.stopPropagation()}>
            <button className="absolute top-2 right-3 text-black" onClick={() => setShowPrivacy(false)}><X size={20} /></button>
            <h2 className="text-xl font-semibold mb-4">Privacy Policy</h2>
            <div className="prose max-w-none text-sm overflow-y-auto">
              {/* Paste privacy policy text here or import it from a separate component */}
              <p><strong>Effective Date:</strong> May 14, 2025</p>
              <p>We respect your privacy. Please read our full policy on how we handle your data, cookies, and third-party services. For more details, contact us at <strong>info@ageduhub.in</strong>.</p>
              {/* Trimmed for brevity */}
            </div>
          </div>
        </div>
      )}

      {/* Modal - Terms of Use */}
      {showTerms && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex justify-center items-center p-4" onClick={() => setShowTerms(false)}>
          <div className="bg-white text-black max-w-2xl w-full p-6 rounded-lg relative overflow-y-auto max-h-[80vh]" onClick={(e) => e.stopPropagation()}>
            <button className="absolute top-2 right-3 text-black" onClick={() => setShowTerms(false)}><X size={20} /></button>
            <h2 className="text-xl font-semibold mb-4">Terms of Use</h2>
            <div className="prose max-w-none text-sm overflow-y-auto">
              <p><strong>Effective Date:</strong> May 14, 2025</p>
              <p>By accessing AG EDU HUB Foundation, you agree to comply with our terms. Unauthorized use or distribution of content is prohibited. Contact us for queries at <strong>info@ageduhub.in</strong>.</p>
              {/* Trimmed for brevity */}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
